var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-main"},[_c('div',{staticClass:"header-bg"},[_c('el-image',{staticClass:"fold",attrs:{"src":_vm.collapse ? _vm.unFold : _vm.fold},on:{"click":_vm.handleCollapse}}),_c('div',{staticClass:"nav-content"},[_c('div',{staticClass:"nav-right"},[_c('OEMPortrait')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }